import { render, staticRenderFns } from "./SelectNumberOfPeople.vue?vue&type=template&id=7b23f191"
import script from "./SelectNumberOfPeople.vue?vue&type=script&lang=js"
export * from "./SelectNumberOfPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports